import {WebConferenceTypes} from "@share/web-conferences/enums/WebConferenceTypes";
import {SDK_MODE} from "agora-rtc-sdk-ng";
import {AgoraClientModes as AgoraClientModesEnum} from "@share/web-conferences/enums/AgoraClientModes";

/**
 * Defines agora client mode:
 * if web conference is meeting then rtc
 * else lives
 * @param type
 */
const defineMode = (type: WebConferenceTypes): SDK_MODE => {
    return type == WebConferenceTypes.Meeting ? AgoraClientModesEnum.Rtc : AgoraClientModesEnum.Live;
}

export {defineMode}
